import { Alert, Box, Container } from "@mui/material";
import React, { useCallback } from "react";
import BackBtn from "../../widgets/BackBtn";
import useApiEp from "../../hooks/useApiEp";
import TopTitleActions from "../../widgets/TopTitleActions";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "../../widgets/DataTable";
import { useNavigate } from "react-router-dom";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse } from "../../utils/util";

const BusinessList = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useApiEp(
    `/partner/businesses-list`
  );
  const handleAction = useCallback((action, id) => {
    switch (action) {
      case "view":
        navigate(`/home/${id}/business-detail`);
        break;
      case "edit":
        navigate(`/home/${id}/edit-business`);
        break;
      default:
        console.warn("unknown action", id);
    }
  }, []);
  if (isLoading) {
    return <MuPb />;
  }

  if (isError) {
    return <Alert variant="outlined">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Container sx={{ mt: 3 }}>
      <BackBtn />
      <TopTitleActions
        title={"Businesses List"}
        actions={[
          {
            icon: <AddIcon />,
            label: "Add Business",
            action: () => {
              navigate(`/home/create-business`);
            },
          },
        ]}
      />
      <DataTable
        sx={{ mb: 1 }}
        columns={[
          {
            id: "serial",
            label: "S.No.",
            render: (_v, _row, idx) => idx + 1,
          },
          { id: "display_name", label: "Name" },
          { id: "business_id", label: "Business Id" },
          { id: "user_name", label: "Username" },
          { id: "email", label: "Email" },
          {
            id: "createdOn",
            label: "Created On",
            render: (v) =>
              new Date(v).toLocaleString("en-IN", {
                dateStyle: "medium",
              }),
          },
        ]}
        actions={["view", "edit"]}
        rows={data || []}
        page={1}
        limit={100}
        totalPages={1}
        onPageChange={null}
        onAction={handleAction}
      />
    </Container>
  );
};

export default BusinessList;
